module.exports = __webpack_public_path__ + "media/maps-markers/red-pin-7f0fbc92.svg";